class Biorhythm {
    constructor(options) {

        var defaults = {
            selector: '#app-astrology-biorhythm'
        };
        this.params = Object.assign({}, defaults, options || {});

        if (!window.jQuery) {
            console.log('jQuery is required by Biorhythm module');
            return;
        }
        this.$el = jQuery(this.params.selector);
        this.colors = ["#008000", "#FF0000", "#0000ff", "#ff00ff"];
        this.periods = [23, 28, 33, 0];
        this.labels = ["Σωματικός", "Συναισθηματικός", "Διανοητικός", "Γενικός Δείκτης"];
        this.basedate = null;
        this.s_basedate = null;
        this.data = this.params.data;
        this.update();
    }

    addEvents() {
        document.querySelector('form[name="biorhythm-form"]').addEventListener('submit', (event) => {
            event.preventDefault();
            this.update();
        });
    }

    precise_round(num, decimals) {
        return Math.round(num * Math.pow(10, decimals)) / Math.pow(10, decimals);
    }

    generate_data(birth, span) {

        var days = this.basedate.getTime() - birth.getTime();
        days /= 1000;
        days /= 86400;

        var graph_data = [];
        var lines = [];
        var line = [];
        var criticals = [];
        var ti;
        line = [
            [-span, 0],
            [+span, 0]
        ];
        graph_data.push({
            "color": "#000",
            "label": "",
            "data": line
        });

        for (ti = 0; ti < 4; ++ti) {
            line = [];
            graph_data.push({
                "color": this.colors[ti],
                "label": this.labels[ti],
                "data": line
            });
            lines.push(line);
        }

        for (ti = 0; ti < 3; ++ti) {
            line = [];
            graph_data.push({
                "color": this.colors[ti],
                label: null,
                points: {
                    show: true,
                    symbol: "cross",
                    radius: 6
                },
                lines: {
                    show: false
                },
                "data": line
            });
            criticals.push(line);
        }

        for (var i = -span; i <= span; i += 0.05) {

            if (this.precise_round(i, 2) === 0) {
                line = [
                    [i, -1.10],
                    [i, +1.10]
                ];
                graph_data.push({
                    "color": "#eec752",
                    "label": "",
                    "data": line
                });
            } else if ((i % 7 === 0) && (span <= 22)) { }

            var tot = 0;
            var tmp_num;
            var h;
            for (var j = 0; j < 3; ++j) {
                var x = i + days;
                h = Math.sin(2.0 * Math.PI * x / this.periods[j]);
                tot += h;
                lines[j].push([i, h]);

                if (this.precise_round(i, 2) === 0.00) {
                    tmp_num = this.precise_round(h, 2) * 100;
                    this.$el.find('[data-role="biorhythm-result-' + j + '"]').html(tmp_num.toFixed() + "%");
                }

                if (this.precise_round(h, 2) === 0.00) {
                    criticals[j].push([i, h]);
                }
            }
            if (this.precise_round(i, 2) === 0.00) {
                tmp_num = this.precise_round(tot / 3, 2) * 100;
                this.$el.find('[data-role="biorhythm-result-3"]').html(tmp_num.toFixed() + "%");
            }
            lines[3].push([i, tot / 3]);
        }

        return graph_data;
    }

    format_x(val) {

        if ((val % 2) !== 0) {
            return "";
        }
        var d;
        if (window.basedate) {
            d = new Date(window.basedate);
        } else {
            d = new Date();
        }
        var s = "";
        d.setDate(d.getDate() + val);
        s = "" + d.getDate() + "/" + (d.getMonth() + 1);
        return s;
    }

    format_y(val) {
        return (val * 100) + "%";
    }

    update() {
        var span = "15";
        var birth = this.getBirthDate();
        this.basedate = this.getResultDate();
        window.basedate = this.basedate;
        var data = this.generate_data(birth, span);
        this.plot_graph(data, span);
        return true;
    }

    plot_graph(data, span) {
        this.$el.find("#bioChart").html("");

        if (data.length <= 0) {
            return;
        }
        var ts;
        if (span <= 22) {
            ts = 1;
        } else {
            ts = 7;
        }
        var markings = [{
            color: "#f8fcfa",
            yaxis: {
                from: 0
            }
        }, {
            color: "#faf5f5",
            yaxis: {
                to: 0
            }
        }];

        var cfg = {
            legend: {
                position: "ne",
                show: true,
                noColumns: 2,
                backgroundOpacity: 0
            },
            grid: {
                hoverable: true,
                autoHighlight: false,
                aboveData: false,
                color: "#000",
                markings: markings
            },
            series: {
                lines: {
                    show: true
                }
            },
            yaxis: {
                min: -1.10,
                max: +1.10,
                tickFormatter: this.format_y,
                alignTicksWithAxis: 1
            },
            xaxis: {
                tickSize: ts,
                tickFormatter: this.format_x,
                alignTicksWithAxis: 1
            }
        };
        jQuery.plot(this.$el.find("#bioChart"), data, cfg);
    }


    getBirthDate() {
        var birthDateYear = parseInt(this.data.birthDateYear);
        var birthDateMonth = parseInt(this.data.birthDateMonth) - 1;
        var birthDateDay = parseInt(this.data.birthDateDay);
        var birthHour = parseInt(this.data.birthHour);
        var birthMinute = parseInt(this.data.birthMinute);
        return new Date(birthDateYear, birthDateMonth, birthDateDay, birthHour, birthMinute, 0, 0);
    }

    getResultDate() {
        var resultDateYear = parseInt(this.data.resultDateYear);
        var resultDateMonth = parseInt(this.data.resultDateMonth) - 1;
        var resultDateDay = parseInt(this.data.resultDateDay);
        return new Date(resultDateYear, resultDateMonth, resultDateDay, 0, 0, 0, 0);
    }
}

export {
    Biorhythm as
        default
};
